var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchools(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke:#b53729;stroke-width:4px;}.cls-3{stroke-dasharray:3.78 3.78;}.cls-4{stroke-dasharray:3.97 3.97;}.cls-5{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.37,
    y: 97.33,
    width: 76.87,
    height: 33.09,
    rx: 1.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.63,
    y1: 105.77,
    x2: 51.46,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.38,
    y1: 105.77,
    x2: 61.21,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.13,
    y1: 105.77,
    x2: 70.96,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.89,
    y1: 105.77,
    x2: 80.72,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.64,
    y1: 105.77,
    x2: 90.47,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.4,
    y1: 105.77,
    x2: 100.22,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 104.15,
    y1: 105.77,
    x2: 109.98,
    y2: 105.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.63,
    y1: 113.87,
    x2: 51.46,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.38,
    y1: 113.87,
    x2: 61.21,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.13,
    y1: 113.87,
    x2: 70.96,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.89,
    y1: 113.87,
    x2: 80.72,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.64,
    y1: 113.87,
    x2: 90.47,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.4,
    y1: 113.87,
    x2: 100.22,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 104.15,
    y1: 113.87,
    x2: 109.98,
    y2: 113.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.63,
    y1: 121.98,
    x2: 51.46,
    y2: 121.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.38,
    y1: 121.98,
    x2: 61.21,
    y2: 121.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.13,
    y1: 121.98,
    x2: 100.31,
    y2: 121.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 104.15,
    y1: 121.98,
    x2: 109.98,
    y2: 121.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.13,
    y1: 62.49,
    x2: 62.13,
    y2: 62.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.35,62.49h-4a11.35,11.35,0,0,0,0,22.7h19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.26,
    y1: 85.19,
    x2: 77.26,
    y2: 85.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.01,
    y1: 85.19,
    x2: 79.01,
    y2: 85.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83,85.19h41.53a10,10,0,0,1,0,20H120"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.01,
    y1: 105.19,
    x2: 116.01,
    y2: 105.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.91,53.12C63,57,63,57.21,63,61s1.92,6.53,9.74,10.14A62.33,62.33,0,0,0,86.14,75.8l-.32-13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.61,68.61a40.52,40.52,0,0,1-4.21,2.31A62.11,62.11,0,0,1,86.11,75.8l-.32-13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86,62.76,42.71,46.53l43-17.06L129,45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.38,43.65l21.71,8.69.11,14.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.55,41.66c0,1.33-2.1,2.42-4.7,2.44s-4.74-1-4.75-2.35,2.09-2.4,4.7-2.43S90.54,40.35,90.55,41.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.21,78.76V71c0-2.44-1.68-4.42-3.75-4.42s-3.75,2-3.75,4.42v7.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchools);
export default __webpack_public_path__ + "static/media/schools.b31db82542e61859a9a7fbf78f2739a1.svg";
export { ForwardRef as ReactComponent };